import style from './App.module.css'
import { Input } from './components/Input/Input';
import { Button } from './components/Button/Button';
import { useEffect, useState } from 'react';
import { login, getOffice, loginIntern } from './api/apiLogin';
import { Logo } from './components/Logo/Logo';


function App() {
  const [loading, setLoading] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [textError, setTextError] = useState('')
  const [textSuccess, setTextSuccess] = useState('')
  const [isOffice, setIsOffice] = useState(false)

  function auth() {
    if (!username || !password) return;

    setTextError('')
    setTextSuccess('')

    setLoading(true)
    login(username, password).then(response => {      
      setLoading(false)
      const {message, status} = response.data
      if (status === 'ok') {
        setTextSuccess('Успешный вход.')
        document.location.href = `${document.location.origin}/new/sales/`
      } else {
        setTextError('Неверный логин или пароль.')
      }
    })
  }

  function authIntern() {
    setTextError('')
    setTextSuccess('')

    setLoading(true)
    loginIntern().then(response => {      
      setLoading(false)
      const {status} = response.data
      if (status === 'ok') {
        setTextSuccess('Успешный вход.')
        document.location.href = `${document.location.origin}/new/sale/`
      } else {
        setTextError('Ошибка быстрой авторизации.')
      }
    })    
  }

  useEffect(() => {
    getOffice().then(response => {      
      setIsOffice(response.data?.data?.is_office || false)
    })
  }, [])

  return (
    <div className={style.back}>
      <Logo />
      <div className={style.container}>
        {
          (textError || textSuccess) &&
          <div className={textError ? style.error : style.success}>
            {textError || textSuccess}
          </div>          
        }

        <div className={style.inputs}>
          <Input label='Логин'
            value={username}
            onInput={(e) => setUsername(e.target.value)}
            onKeyDown={auth}
          />
          <Input
            value={password}
            onInput={(e) => setPassword(e.target.value)}
            onKeyDown={auth}
            label='Пароль'          
            password
          />
        </div>

        <div className={style.buttons}>
          {
            isOffice &&
            <Button
              label='Я Стажёр'
              white
              onClick={authIntern}
            />
          }
          <Button
            label='Войти'
            onClick={auth}
            disabled={!username || !password || loading}
            loading={loading}
          />      
        </div>    
      </div>  
    </div>
  );
}

export default App;
